import AssetCharges from '@components/asset/AssetCharges'
import View from '@components/View'
import { useParams } from 'react-router-dom'

const AssetTasksView = () => {
  const params = useParams()

  return (
    <View title="Tasks/Activities">
      <AssetCharges
        assetCompanyID={parseInt(params.companyID)}
        assetID={params.assetID}
        type="O"
      />
    </View>
  )
}

export default AssetTasksView
